import { registerServiceWorker, setupInstallPrompt } from '../utils/pwaUtils'

// In-app toast notification for foreground push events
function showInAppToast(payload) {
  const { title, body } = payload || {}
  if (!title && !body) return

  const existing = document.getElementById('cams-push-toast')
  if (existing) existing.remove()

  const toast = document.createElement('div')
  toast.id = 'cams-push-toast'
  toast.style.cssText = `
    position: fixed; top: 0; left: 0; right: 0; z-index: 99999;
    padding: 16px 20px; padding-top: max(16px, env(safe-area-inset-top));
    background: linear-gradient(135deg, #2563eb, #4f46e5);
    color: white; font-family: system-ui, sans-serif;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    transform: translateY(-100%); transition: transform 0.3s ease;
    cursor: pointer;
  `
  toast.innerHTML = `
    <div style="font-size:14px;font-weight:600;margin-bottom:2px">${title || 'CAMS 알림'}</div>
    ${body ? `<div style="font-size:12px;opacity:0.9;line-height:1.4">${body}</div>` : ''}
  `
  toast.onclick = () => {
    toast.style.transform = 'translateY(-100%)'
    setTimeout(() => toast.remove(), 300)
    if (payload?.url) window.location.href = payload.url
  }

  document.body.appendChild(toast)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.style.transform = 'translateY(0)'
    })
  })

  setTimeout(() => {
    if (document.getElementById('cams-push-toast')) {
      toast.style.transform = 'translateY(-100%)'
      setTimeout(() => toast.remove(), 300)
    }
  }, 5000)
}

export function initPWA() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      registerServiceWorker().then((registration) => {
        if (!registration) return

        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data && event.data.type === 'PUSH_RECEIVED') {
            showInAppToast(event.data.payload)
          }
          // Phase CL-B M-2: SW 업데이트 안내 — 강제 reload 없이 배너 이벤트만 전달
          if (event.data && event.data.type === 'RELOAD_REQUIRED') {
            try {
              window.dispatchEvent(new CustomEvent('app:reload-required', {
                detail: { version: event.data.version },
              }))
            } catch (_) { /* noop */ }
          }
        })
      })
      setupInstallPrompt()
    })
  }
}
